import React from 'react';

import CareerPathBuilder from './CareerPathBuilder/CareerPathBuilder';
import CareerTools from './CareerTools/CareerTools';

const KnowPharmuni = () => {
    return (
        <>
            <CareerPathBuilder />
            <CareerTools />
        </>
    );
};

export default KnowPharmuni;
